import { useContext } from 'react';
import { DialogContext } from '../contexts/DialogsContext';

// ----------------------------------------------------------------------

const useDialog = () => useContext(DialogContext);

export default useDialog;
